import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import PushPinIcon from '@mui/icons-material/PushPin';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { Pill } from '@/components/shared/Pill';
import { GetInspectionPlansQuery } from '@/__generated__/graphql';
import {
  closeIconStyles,
  pinIconStyles,
} from '@/components/Analysis/Insights/KendoEquipmentTable/styles';
import { abyssColors } from '@/theme/colors';

type PlanPillProps = {
  plan: GetInspectionPlansQuery['getInspectionPlans'][0];
  isSelected?: boolean;
  pinningPlanId?: string | null;
  onClick: () => void;
  onClose: () => void;
  onPinClick: () => void;
  showCloseIcon?: boolean;
  showPinIcon?: boolean;
};

export const PlanPill = ({
  plan,
  isSelected = false,
  pinningPlanId = null,
  onClick,
  onClose,
  onPinClick,
  showCloseIcon = true,
  showPinIcon = true,
}: PlanPillProps) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Box
        sx={{
          border: isSelected ? `1px solid ${abyssColors.primary[300]}` : '1px solid transparent',
          borderRadius: '999px',
          p: '2px',
          cursor: 'pointer',
        }}
        onClick={onClick}
      >
        <Pill
          label={plan.name}
          size="medium"
          type="readonly"
          showCloseIcon={showCloseIcon}
          closeIcon={<CloseIcon />}
          onCloseClick={onClose}
          pinIcon={
            showPinIcon
              ? pinningPlanId === plan.id
                ? <CircularProgress size={16} />
                : plan.isPlanPinned
                  ? <PushPinIcon />
                  : <PushPinOutlinedIcon />
              : undefined
          }
          onPinClick={showPinIcon ? onPinClick : undefined}
          closeIconStyle={closeIconStyles}
          pinIconStyle={pinIconStyles}
        />
      </Box>
    </Box>
  );
};
